import styles from './index.module.scss'
import { useEffect, useRef, useState } from 'react'
import { getToken, setCallbackUrl, setToken } from '../../utils/cookie.js'
import { Spin } from 'antd'
import { isMcpAuthorizationUrl, loadMcpMainPrefix, readMainSession, resolveMcpLogin,
  captureMainSession, isMainSessionCurrent, saveMainSession, saveMcpLoginResume } from '../../utils/mcpOAuth'
import useUrlState from '@ahooksjs/use-url-state'
import request from '../../utils/request.js'
import api from '../../api/index.js'
import { useHistory } from 'react-router-dom'
import { isSpecialUrl, isSpecialLoginUrl, getClientTypeFromRedirect } from '../../utils/util.js'

export default function LoadingPage() {
  const [state, setState] = useUrlState({})
  const history = useHistory()
  const [isOK, setIsOK] = useState(false)
  const [mcpError, setMcpError] = useState('')

  //判断当前是否嵌在iframe
  const isInIframe = () => {
    if (window !== window.top) {
      console.log('在iframe中222')
      return true
    }
    if (window !== window.parent) {
      console.log('在iframe中111')
      return true
    }
    return false
  }

  // 通过ticket获取token并保存
  const getTokenByTicketFunc = async (ticket, redirect) => {
    let isLocal = isSpecialUrl(redirect);
    //特殊判断
    if(isLocal){
      redirect =
        redirect + (redirect.includes('?') ? '&' : '?') + 'ticket=' + ticket
      window.location.href = redirect
      return
    }
    const getCodePromise = await request.get('/saas/prd_code/', {
      params: {
        link: redirect,
      },
    })
    const prd_code = getCodePromise?.data?.data?.prd_code;

    
    let params = {
      params: {
        ticket: ticket,
        redirect: redirect,
        saas: true,
        prod_code: prd_code
      },
    }
    const version = getClientTypeFromRedirect(redirect)
    if (version) {
      params.headers = {
        'X-Client-Type': version,
      }
    }
    request.get('sys/login/', params).then((res) => {
      if (res.data.data.status === 'redirect') {
        window.location.href = res.data.data.login_url
      } else if (res.data.data.status === 'login') {
        setToken(res.data.data.token || '')
        getJumpProcessFunc(redirect)
      }
    })
  }

  // 内部跳转流程
  const getJumpProcessFunc = (redirect) => {
    //点击邀请链接登录的
    const to = localStorage.getItem('to')
    if (to) {
      localStorage.removeItem('to')
      history.push(to)
      return
    }
    //如果是toc产品,直接登录 不需要鉴权
    if(localStorage.getItem('prefix')?.includes('toc')){
      window.location.href = redirect
      return
    }
    let params = {}
    const version = getClientTypeFromRedirect(redirect)
    if (version) {
      params.headers = {
        'X-Client-Type': version,
      }
    }
    const getCodePromise = request.get('/saas/prd_code/', {
      ...params,
      params: {
        link: redirect,
      },
    })
    const getMenuPromise = request.get('/sys/user/menu/', params)
    Promise.all([getCodePromise, getMenuPromise]).then((_) => {
      const [codeRes, menuRes] = _
      const menuList = menuRes?.data?.data
      const { prd_code, menu_code } = codeRes?.data?.data || {}
      // menu_code 用于匹配菜单权限；旧环境未返回时兼容使用 prd_code
      const permissionCode = menu_code || prd_code
      const menusItem = menuList?.find(
        (_) => _.menu_code === permissionCode
      )
      if (menusItem) {
        window.location.href = redirect
      } else {
        // 没有项目权限
        let path = '/saas/guidePage'
        if (prd_code) {
          setCallbackUrl(redirect)
          path =
            path +
            '?project=' +
            (prd_code?.split('_') || [])?.at(0) +
            '&fromLogin=true'
        }
        history.push(path)
      }
    })
  }

   //根据域名获取产品编码
  const getPrdCodeFunc = (link) => {
    return api.getPrdCode(link).then((res) => {
      return res?.data?.data
    })
  }

  //获取对于产品的配置
  const getPrdConfig = (prd_code) => {
    api.getPrdConfig(prd_code).then((res) => {
      if(res?.data?.code === 0){
        localStorage.setItem('prefix', res.data?.data?.prefix || '')
        setIsOK(true)
      }else{
        setIsOK(false)
      }
    }).catch(sea=>{
      setIsOK(false);
    })
  }

  useEffect(() => {
    if (isMcpAuthorizationUrl(state.redirect)) {
      let cancelled = false
      const restoreMcp = async () => {
        try {
          saveMcpLoginResume(state.redirect)
          const prefix = await loadMcpMainPrefix()
          if (cancelled) return
          const snapshot = captureMainSession(prefix)
          const existing = !state.ticket && !state.code && readMainSession(prefix)
          const result = existing ? { session: existing } : await resolveMcpLogin(
            { ticket: state.ticket, loginCode: state.code }, state.redirect
          )
          if (cancelled) return
          if (!isMainSessionCurrent(snapshot, prefix)) {
            setMcpError('登录状态已变化，本次恢复已停止，请返回授权页面重新确认。')
            return
          }
          if (result.loginUrl) window.location.assign(result.loginUrl)
          else {
            if (!saveMainSession(result.session, prefix, snapshot)) return
            // OAuth 恢复不检查菜单、不切企业；返回页面后等待用户点击。
            window.location.replace(state.redirect)
          }
        } catch (_) {
          if (!cancelled) setMcpError('Main 登录恢复失败，请返回授权页面重新登录。')
        }
      }
      restoreMcp()
      return () => { cancelled = true }
    }
    //本地及wps直接转发
    if(isSpecialLoginUrl(state.redirect)){
      let redirect = state.redirect + (state.redirect.includes('?') ? '&' : '?') + 'ticket=' + state.ticket
      window.location.href = redirect
      return
    }
    getPrdCodeFunc(state.redirect).then(res=>{
      if(res?.prd_code){
        getPrdConfig(res?.prd_code)
      }else{
        setIsOK(false)
      }
    }).catch(sea=>{
      setIsOK(false);
    })
  }, [])

  useEffect(()=>{
    if(!isOK){
      return
    }
    let isLocal = isSpecialUrl(state.redirect);
    if (getToken() && !isLocal) {
      getJumpProcessFunc(state.redirect)
      return
    }
    getTokenByTicketFunc(state.ticket, state.redirect)
  }, [isOK])

  return (
    <div className={styles.root}>
      <Spin></Spin>
      {mcpError && <div role="alert">{mcpError}<a href={state.redirect}>返回授权页面</a></div>}
    </div>
  )
}
